/**
 * Query Keys Factory for Cases Module
 * Centralized query key management for type safety and consistency
 */
export const queryKeys = {
  // Case list queries
  caseList: {
    all: ['cases', 'list'],
    list: (filter, paginationParams) => [
      'cases',
      'list',
      filter,
      paginationParams?.limit,
      paginationParams?.pagination_token,
      paginationParams?.pagination_direction,
    ],
  },
  // Case stage queries
  caseStages: {
    all: ['cases', 'stages'],
    list: (practice_area, excludeFromLoading, isCase, isLeads, loadFullList, limit) => [
      'cases',
      'stages',
      'list',
      practice_area,
      excludeFromLoading,
      isCase,
      isLeads,
      loadFullList,
      limit,
    ],
    // Per-page dropdown cache key — each unique combination of filters + page + search
    // gets its own entry so AsyncPaginate pages are cached independently.
    dropdown: (practiceAreaId, isLeadSpecific, search, page, pageSize) => [
      'cases',
      'stages',
      'dropdown',
      practiceAreaId ?? null,
      isLeadSpecific,
      search,
      page,
      pageSize,
    ],
  },
  // Case notes queries
  caseNotes: {
    all: ['cases', 'notes'],
    list: (filter, paginationParams) => [
      'cases',
      'notes',
      'list',
      filter?.case_id,
      filter?.note_type,
      filter?.keyword,
      filter?.is_assignee,
      paginationParams?.limit,
      paginationParams?.pagination_token,
      paginationParams?.pagination_direction,
    ],
  },
  // Secure messages queries
  secureMessages: {
    all: ['cases', 'secure-messages'],
    list: (params) => [
      'cases',
      'secure-messages',
      'list',
      params?.case_id,
      params?.is_global,
      params?.pageLimit,
      params?.is_read,
      params?.author_id,
      params?.resolution_status,
      params?.tenantId,
      params?.tenantSk,
      params?.isCase,
      params?.isLeads,
      params?.isLeadSpecific,
      params?.isFromCaseSpecificModule,
    ],
  },
  // Case matter queries
  caseMatter: {
    all: ['cases', 'matter'],
    list: (practice_area, isCase, isLeads) => ['cases', 'matter', 'list', practice_area, isCase, isLeads],
  },
  // Contact list queries
  contacts: {
    all: ['contacts'],
    search: (query, contactType, isCase, isLeads) => ['contacts', 'search', query, contactType, isCase, isLeads],
    courtSearch: (query, isCase, isLeads) => ['contacts', 'court-search', query, isCase, isLeads],
    initial: (isCase, isLeads) => ['contacts', 'initial', isCase, isLeads],
  },
  // Venue queries
  venues: {
    all: ['venues'],
    list: (practiceAreaId, excludeFromLoading, isCase, isLeads) => ['venues', 'list', practiceAreaId, excludeFromLoading, isCase, isLeads],
  },
  // Global tags queries
  globalTags: {
    all: ['global-tags'],
    list: (practiceAreaId, isCase, isLeads) => ['global-tags', 'list', practiceAreaId, isCase, isLeads],
  },
  // Office location queries
  officeLocations: {
    all: ['office-locations'],
    list: (isCase, isLeads) => ['office-locations', 'list', isCase, isLeads],
  },
  // Lead stage queries
  leadStages: {
    all: ['leads', 'stages'],
    dropdown: (practiceAreaId, caseId, search, page, pageSize) => [
      'leads',
      'stages',
      'dropdown',
      practiceAreaId ?? null,
      caseId ?? '',
      search,
      page,
      pageSize,
    ],
  },
};
